export default __webpack_public_path__ + "static/media/77t.89ddc7dd.jpg";